import React, {Component} from 'react'; 
import axios from 'axios';
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import withRouter from '../components/withRouter';  
import ServiceListContent from '../components/ServiceListContent'; 
  
import {api_base_url, base_url} from '../common/Constants';

class ServiceList extends React.Component{

    constructor(props){
        super(props);

        
        this.state = { 
            loading:1,
            type:[],
            category:[]
        }
    }

     componentDidMount()
    {
        
        var data = { id : this.props.params.id} 
            axios.post(api_base_url+"category", data).then(response=>{
                this.setState({category:response.data}); 
                this.setState({loading:0});

                console.log(this.state.category);
                
            }); 
    }
    componentDidUpdate(prevProps)
    {
        if(this.props.params.id !== prevProps.params.id)
        {
            var data = { id : this.props.params.id} 
            axios.post(api_base_url+"category", data).then(response=>{
                this.setState({category:response.data}); 
                this.setState({loading:0});
            }); 
        }
    }
   
 
    render()
    {
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
        return (
            <div className="page-wrapper">
                <Header/>  
                <ServiceListContent id={this.props.params.id} category={this.state.category}  />  
                <Footer/>
            </div>
       
        )
    }

}
export default withRouter(ServiceList);